import eventListeners from './event-listeners';
import documentKeydownHandler from '../handlers/document-keydown-handler';

const keydownListener = (element) => {
  eventListeners.add(element, 'keydown', documentKeydownHandler, false);
};

export default keydownListener;
